/* src/app/ships/bulk-cards/bulk-cards.component.css */
input.ng-invalid.ng-touched {
  border: 1px solid red;
}
/*# sourceMappingURL=bulk-cards.component.css.map */
